import PropTypes from "prop-types";
import React from "react";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import Transition from "./Transition";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Zoom from "@material-ui/core/Zoom";
import moment from "moment";
import "moment-duration-format";
import async from "async";

import _ from "lodash";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import FormComponent from "../FormComponent";

//- graphics
import CircularProgress from "@material-ui/core/CircularProgress";
import GreenChecked from "../../images/icons/greenChecked.svg";
import AuthUserContainer from "../../containers/AuthUser";
import FormTextArea from "../form/FormTextArea";
import TimeClockContainer from "../../containers/TimeClock/TimeClock";
import WarningIconSvg from "../../images/icons/warningIcon.svg";
import ErrorIcon from "@material-ui/icons/Error";
import { red } from "@material-ui/core/colors";
import Note from "../Note";

function styles() {
  return {
    inner: {
      padding: "40px 30px",
    },
    dialogTitle: {
      fontSize: 20,
      borderBottom: "1px solid #eee",
      paddingBottom: 5,
      marginBottom: 10,
      fontWeight: 300,
      display: "flex",
      justifyContent: "space-between",
    },
    dialogRoot: {
      //overflow: 'visible'
      alignItems: "end",
    },
    closeButton: {
      position: "absolute",
      right: 15,
      top: 15,
      color: "#555",
    },
    addButton: {
      //verticalAlign : 'middle',
      //textDecoration: 'none',
      //marginBottom: 0,
      //borderRadius: 100,
      padding: "10px 35px",
      fontSize: 16,
      marginTop: 20,
      color: "white",
      marginRight: 10,
    },

    isSaving: {
      marginLeft: 20,
      fontSize: 16,
      color: "#1565C0",
    },
    savingSuccessful: {
      marginLeft: 20,
      fontSize: 16,
      color: "#2E7D32",
    },
    pleaseSelect: {
      fontStyle: "italic",
      color: "#777",
    },
    currentShiftContainer: {
      //borderBottom: `1px solid #eee`,
      //backgroundColor: "#fcfcfc",
      padding: `5px 20px`,
      margin: "10px 0px",
      borderRadius: 5,
      fontSize: "110%",
    },
    currentShiftTitle: {
      display: "flex",
      alignItems: "center",
      fontSize: 17,
    },
    errorIcon: {
      color: "#F44336",
      marginRight: 10,
    },
    greenCheckedIcon: {
      display: "inline-block",
      width: 20,
      height: 20,
      backgroundImage: `url('${GreenChecked}')`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      verticalAlign: "middle",
      marginRight: 2,
      marginLeft: 5,
    },
    currentLabel: {
      color: "#333",
      marginLeft: 2,
      marginRight: 5,
      fontWeight: 500,
    },
    currentValue: {},

    miniWarningIcon: {
      display: "inline-block",
      width: 22,
      height: 22,
      backgroundImage: `url('${WarningIconSvg}')`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      verticalAlign: "middle",
      marginRight: 5,
      marginLeft: 0,
      marginTop: 6,
    },
    miniErrorIcon: {
      width: 22,
      height: 22,
      color: red[400],
      marginLeft: 0,
      marginTop: 0,
      marginRight: 2,
      verticalAlign: "middle",
    },
  };
}

class ClearTimeShiftAudit extends FormComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,
      savingSuccessful: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { timeClockShifts } = this.props;
    if (timeClockShifts && prevProps.timeClockShifts !== timeClockShifts) {
      const { auditStatus } = timeClockShifts;
      return this.setState({
        auditStatus,
        note: "",
      });
    }
  }

  handleSubmit = () => {
    const { timeClockShiftManagerUpdate, showErrors } = this.props;

    const formFieldError = {};
    _.values(this.requiredPathMap).forEach(({ path, label }) => {
      if (!this.state[path]) {
        formFieldError[path] = `${label} is required`;
      }
    });
    if (_.keys(formFieldError).length) {
      this.setState({ formFieldError });
      return showErrors(_.values(formFieldError));
    }

    const { timeClockShifts } = this.props;
    const { note } = this.state;

    if (!timeClockShifts) {
      return showErrors(["Missing selected time clock shift."]);
    }

    const timeClockShiftIds = _.map(timeClockShifts, "timeClockShiftId");

    this.setState({ isSaving: true, savingSuccessful: false });
    async.eachSeries(
      timeClockShiftIds,
      (timeClockShiftId, callback) => {
        const params = {
          timeClockShiftId,
          clearAuditStatus: true,
          note,
        };

        timeClockShiftManagerUpdate({
          params,
          callback,
        });
      },
      (err) => {
        if (err) {
          this.setState({ isSaving: false });
          showErrors(err);
          return;
        }
        _.delay(() => {
          this.props.afterSave();
          this.handleClose();
        }, 400);
      }
    );
  };

  handleClose = () => {
    this.setState({
      savingSuccessful: false,
      isSaving: false,
    });
    this.props.onClose();
  };

  render() {
    const { open, classes, timeClockShifts } = this.props;
    return (
      <Dialog
        open={open}
        TransitionComponent={Transition}
        onClose={this.handleClose}
        fullWidth={true}
        maxWidth={"md"}
        classes={{ scrollPaper: classes.dialogRoot }}
      >
        {!_.isEmpty(timeClockShifts) && this.renderContent()}
      </Dialog>
    );
  }

  renderContent = () => {
    const { classes, timeClockShifts, timeClockUserMap } = this.props;
    const isRequired = true;
    const { isSaving, savingSuccessful } = this.state;

    const { shiftForUserId } = _.first(timeClockShifts);
    const user = timeClockUserMap[shiftForUserId] || {
      firstName: "Missing",
      lastName: "",
    };

    return (
      <div className={classes.inner}>
        <div className={classes.dialogTitle}>
          <div>
            Clear Flag for{" "}
            <strong>
              {user.firstName} {user.lastName}
            </strong>
          </div>
          <div>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        <form>
          <Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
            {timeClockShifts.map((timeClockShift) => {
              return (
                <div key={`clear_${timeClockShift.timeClockShiftId}`}>
                  {this.renderShowCurrentShift(timeClockShift)}
                </div>
              );
            })}

            <Note>
              <strong>Note:</strong> If you can fix this flagged shift with a
              time clock update, please do that and it may clear the audit flag.
              <br />
              If the hours on this flagged shift are correct then please hit the
              "Clear Flag On Shift" button below with a reason why the hours
              fall outside our shift rules
            </Note>

            <FormTextArea
              {...this.setForm(
                "note",
                "Reason hours fall outside normal shift rules.",
                isRequired
              )}
              rows={2}
            />

            <Grid
              item
              md={12}
              style={{ display: "flex", alignItems: "baseline" }}
            >
              <Button
                variant="contained"
                color="primary"
                className={classes.addButton}
                onClick={this.handleSubmit}
                disabled={isSaving || savingSuccessful}
              >
                Hours are correct. Clear Audit Flag
              </Button>

              <Button
                variant="outlined"
                className={classes.button}
                onClick={this.handleClose}
              >
                Close
              </Button>

              <Zoom
                in={isSaving}
                style={{ transitionDelay: isSaving ? "0ms" : "0ms" }}
                mountOnEnter
                unmountOnExit
              >
                <div className={classes.isSaving}>
                  <CircularProgress style={{ verticalAlign: "middle" }} />
                  <span style={{ paddingLeft: 10 }}>Saving...</span>
                </div>
              </Zoom>

              <Zoom
                in={savingSuccessful}
                style={{
                  transitionDelay: savingSuccessful ? "250ms" : "0ms",
                }}
              >
                <div className={classes.savingSuccessful}>
                  <div className={classes.greenCheckedIcon} />
                  <span style={{ paddingLeft: 10 }}>
                    Employee's shift updated successfully.
                  </span>
                </div>
              </Zoom>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  };

  renderShowCurrentShift = (timeClockShift) => {
    const { classes } = this.props;

    if (!timeClockShift) {
      return (
        <Grid item xs={12}>
          <div className={classes.currentShiftContainer}>
            <div className={classes.pleaseSelect}>Missing time shift</div>
          </div>
        </Grid>
      );
    }

    const {
      clockInDateTime,
      clockOutDateTime,
      auditStatus,
      auditReason,
    } = timeClockShift;

    const isFlagged = auditStatus === "WARNING" || auditStatus === "ERROR";

    if (!clockOutDateTime) {
      const clockInMoment = moment(clockInDateTime);
      const duration = moment.duration(moment().diff(clockInMoment));

      return (
        <Grid item xs={12}>
          <div className={classes.currentShiftContainer}>
            <div className={classes.currentShiftTitle}>
              <div className={classes.greenCheckedIcon} />
              Employee is currently logged in
            </div>
            <div>
              <span className={classes.currentLabel}>
                Clock in date / time:
              </span>
              <span className={classes.currentValue}>
                {clockInMoment.format("M/D h:mm a")}
              </span>
            </div>
            <div style={{ marginTop: 5 }}>
              <span className={classes.currentLabel}>Current duration:</span>
              <span className={classes.currentValue}>
                {moment.duration(duration).format("d [days], h [hrs], m [min]")}
              </span>
            </div>

            {isFlagged && (
              <div style={{ marginTop: 5 }}>
                {auditStatus === "WARNING" && (
                  <span className={classes.miniWarningIcon} />
                )}

                {auditStatus === "ERROR" && (
                  <ErrorIcon className={classes.miniErrorIcon} />
                )}
                <span>{auditReason}</span>
              </div>
            )}
          </div>
        </Grid>
      );
    }

    const clockInMoment = moment(clockInDateTime);
    const clockOutMoment = moment(clockOutDateTime);
    const duration = moment.duration(
      moment(clockOutMoment).diff(clockInMoment)
    );

    return (
      <Grid item xs={12}>
        <div className={classes.currentShiftContainer}>
          <div>
            <span className={classes.currentLabel}>Clock in date / time: </span>
            <span className={classes.currentValue}>
              {clockInMoment.format("M/D h:mm a")}
            </span>
          </div>
          <div style={{ marginTop: 5 }}>
            <span className={classes.currentLabel}>
              Clock out date / time:{" "}
            </span>
            <span className={classes.currentValue}>
              {clockOutMoment.format("M/D h:mm a")}
            </span>
          </div>
          <div style={{ marginTop: 5 }}>
            <span className={classes.currentLabel}>Shift Duration: </span>
            <span className={classes.currentValue}>
              {moment.duration(duration).format("d [days], h [hrs], m [min]")}
            </span>
          </div>

          {isFlagged && (
            <div style={{ marginTop: 5 }}>
              {auditStatus === "WARNING" && (
                <span className={classes.miniWarningIcon} />
              )}

              {auditStatus === "ERROR" && (
                <ErrorIcon className={classes.miniErrorIcon} />
              )}
              <span>{auditReason}</span>
            </div>
          )}
        </div>
      </Grid>
    );
  };
}

ClearTimeShiftAudit.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  timeClockShiftManagerUpdate: PropTypes.func.isRequired,
  afterSave: PropTypes.func.isRequired,
  timeClockShifts: PropTypes.array,
  timeClockUserMap: PropTypes.object,
};

export default _.flow([
  withStyles(styles, { withTheme: true }),
  AuthUserContainer,
  TimeClockContainer,
])(ClearTimeShiftAudit);
